
const state = {
  zsmAppGoodDetailList: [], // 章节详情数据
  albumDataInfo: {} // 章节信息
}

const mutations = {

}

const actions = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
